import { UpdateControlMetadata } from '../validators/helpers';

export function Placeholder(placeholder: string) {
  return function (target: any, propertyKey: string) {
    UpdateControlMetadata(target, propertyKey, { placeholder });
  }
}
